module.exports = __webpack_public_path__ + "static/media/pet-photo.159dbb43.svg";